interface CreateResourceUrlOptions {
  include?: string[];
  filters?: Record<string, unknown>;
  sort?: string;
  per_page?: number;
}

const isNotFirstParam = (str: string) => str.substring(str.length - 1) !== "?";

export const createResourceUrl = (resource: string, options?: CreateResourceUrlOptions) => {
  let resourceString = resource;

  if (!options) {
    return resourceString;
  }

  resourceString += "?";

  if (options?.include) {
    resourceString += `include=${options?.include?.join(",")}`;
  }

  if (options?.filters) {
    if (isNotFirstParam(resourceString)) {
      resourceString += "&";
    }

    const entries = Object.entries(options?.filters).filter((item) => item[1] !== null);
    const filters = entries.map(([property, value]) => `filter[${property}]=${value}`).join("&");

    resourceString += filters;
  }

  if (options?.sort) {
    if (isNotFirstParam(resourceString)) {
      resourceString += "&";
    }

    resourceString += `sort=${options.sort}`;
  }

  if (options?.per_page) {
    if (isNotFirstParam(resourceString)) {
      resourceString += "&";
    }

    resourceString += `per_page=${options.per_page}`;
  }

  return resourceString;
};
